import type { CoverageConfigModel } from '~/components/types/coverage-types';

export const INVOICE_BASE_TYPE = 'generic_invoice';

// Prefers the BE-resolved `damage_assessment_base_type` so custom DA type configs
// (System Configuration → Damage Assessment Types) are matched correctly. Falls back
// to the raw `damage_assessment_type` against the literal for transitional safety
// (e.g. older fixtures/responses that predate the resolved field).
export const isInvoiceDamageAssessment = (
  config: Pick<CoverageConfigModel, 'damage_assessment_base_type' | 'damage_assessment_type'>
): boolean => {
  if (config.damage_assessment_base_type) {
    return config.damage_assessment_base_type === INVOICE_BASE_TYPE;
  }
  return config.damage_assessment_type === INVOICE_BASE_TYPE;
};
